import PropTypes from "prop-types";
import BaseComponent from "common/Components/BaseComponent";
import { SESSION_ACTIVE_CUSTOMER_ACCESS_REVOKED_MESSAGE, SESSION_ACTIVE_CUSTOMER_ACCESS_REVOKED_TITLE } from "common/Constants/SessionMe.constants";
import {
  StyledCustomerAccessRevokedHint,
  StyledCustomerAccessRevokedMessage,
  StyledCustomerAccessRevokedText,
  StyledCustomerAccessRevokedTitle,
} from "./CustomerAccessRevoked.styles";

const DEFAULT_TITLE = SESSION_ACTIVE_CUSTOMER_ACCESS_REVOKED_TITLE;
const DEFAULT_HINT =
  "Use the customer selector in the header to switch to another customer.";

const CustomerAccessRevoked = ({
  message = SESSION_ACTIVE_CUSTOMER_ACCESS_REVOKED_MESSAGE,
  title = DEFAULT_TITLE,
  hint = DEFAULT_HINT,
  withLayout = true,
}) => {
  const content = (
    <StyledCustomerAccessRevokedMessage role="alert">
      <StyledCustomerAccessRevokedTitle>{title}</StyledCustomerAccessRevokedTitle>
      <StyledCustomerAccessRevokedText>{message}</StyledCustomerAccessRevokedText>
      <StyledCustomerAccessRevokedHint>{hint}</StyledCustomerAccessRevokedHint>
    </StyledCustomerAccessRevokedMessage>
  );

  if (withLayout) {
    return <BaseComponent>{content}</BaseComponent>;
  }

  return content;
};

CustomerAccessRevoked.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  hint: PropTypes.string,
  withLayout: PropTypes.bool,
};

export default CustomerAccessRevoked;
